import { render, staticRenderFns } from "./DeductionSequence.vue?vue&type=template&id=72773972&scoped=true"
import script from "./DeductionSequence.vue?vue&type=script&lang=js"
export * from "./DeductionSequence.vue?vue&type=script&lang=js"
import style0 from "./DeductionSequence.vue?vue&type=style&index=0&id=72773972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72773972",
  null
  
)

export default component.exports